export const SignIn = 'signin'
export const SignUp = 'signup'

export const GA_EVENT_PREFIX_AUTH = 'authentication'
export const GA_EVENT_LOGIN = `${GA_EVENT_PREFIX_AUTH}.user_login`
export const GA_EVENT_SIGN_UP = `${GA_EVENT_PREFIX_AUTH}.user_sign_up`

export const EVENT_LABEL_LOCATION = {
	default: 'platform_auth',
	gatedContent: 'gated_content'
}
export const UI_DELAY = 1200
